import { Component, ElementRef, HostListener, Input, OnChanges } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [NgClass, RouterModule, NgIf],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnChanges {
  @Input() currentRoute: string = '';

  routerUrl: string = '';
  menuMobileAberto: boolean = false;
  dropdownConsultasAberto: boolean = false;
  dropdownQualidadeAberto: boolean = false;
  dropdownConsultasMobileAberto: boolean = false;
  dropdownQualidadeMobileAberto: boolean = false;

  rotasDeConsultas: string[] = [
    '/planejamento-orcamentario-apresentacao',
    '/caq-apresentacao',
    '/financiamento-atual-necessario',
    '/resultado/projecao-orcamentaria',
    '/resultado/relatorio-caq',
    '/resultado/relatorio-financiamento-das-escolas',
    '/indicadores/projecao-orcamentaria',
    '/edicao-relatorio-1/acesso-oferta-educacional/diagnostico-matricula',
    '/custo-por-escola-apresentacao',
    '/relatorio-receitas-despesas-apresentacao'
  ];

  rotasDePadraoQualidade: string[] = [
    '/pqr',
    '/qualidade'
  ];

  // URL do documento de dimensões e justificativas
  pqrDocumentUrl: string = 'assets/20260903_PQR_alterado.remuneracao_VF.pdf';
  // URL do documento de metodologia
  metodologiaDocumentUrl: string = 'assets/20260904_SimCAQ_Aspectos_Metodologicos_SET2026_VFinal.pdf';

  constructor(
    private elementRef: ElementRef,
    public featureFlagService: FeatureFlagService,
  ) { }

  ngOnChanges(): void {
    this.routerUrl = this.currentRoute;
  }

  aoMudarRota(rota: string) {
    this.routerUrl = rota;
    this.fecharTodosDropdowns();
    this.menuMobileAberto = false;
  }

  alternarDropdownConsultas() {
    const estaAberto = this.dropdownConsultasAberto;
    this.fecharTodosDropdowns();
    this.dropdownConsultasAberto = !estaAberto;
  }

  alternarDropdownQualidade() {
    const estaAberto = this.dropdownQualidadeAberto;
    this.fecharTodosDropdowns();
    this.dropdownQualidadeAberto = !estaAberto;
  }

  alternarDropdownConsultasMobile() {
    this.dropdownConsultasMobileAberto = !this.dropdownConsultasMobileAberto;
    this.dropdownQualidadeMobileAberto = false;
  }

  alternarDropdownQualidadeMobile() {
    this.dropdownQualidadeMobileAberto = !this.dropdownQualidadeMobileAberto;
    this.dropdownConsultasMobileAberto = false;
  }

  alternarMenuMobile() {
    this.menuMobileAberto = !this.menuMobileAberto;
    if (!this.menuMobileAberto) {
      this.dropdownConsultasMobileAberto = false;
      this.dropdownQualidadeMobileAberto = false;
    }
  }

  fecharTodosDropdowns() {
    this.dropdownConsultasAberto = false;
    this.dropdownQualidadeAberto = false;
  }

  isConsultaAtiva(): boolean {
    return this.rotasDeConsultas.some(r => this.routerUrl.startsWith(r));
  }

  isPadraoQualidadeAtivo(): boolean {
    return this.rotasDePadraoQualidade.some(r => this.routerUrl.startsWith(r));
  }

  @HostListener('document:click', ['$event'])
  aoClicarDocumento(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.fecharTodosDropdowns();
    }
  }
}
